import script from "./AgentsTableUpTimeCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentsTableUpTimeCell.vue?vue&type=script&setup=true&lang=ts"

import "./AgentsTableUpTimeCell.vue?vue&type=style&index=0&id=cac28fb6&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cac28fb6"]])

export default __exports__